import { render, staticRenderFns } from "./ClientsFilesTab.vue?vue&type=template&id=bab5b24c&scoped=true&"
import script from "./ClientsFilesTab.vue?vue&type=script&lang=js&"
export * from "./ClientsFilesTab.vue?vue&type=script&lang=js&"
import style0 from "./ClientsFilesTab.vue?vue&type=style&index=0&id=bab5b24c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab5b24c",
  null
  
)

export default component.exports